import { Drawer, Spin, Dropdown } from "antd";
import { useState, useEffect, useRef, useCallback } from "react";
import echo from "../../utils/echo";
import { useDispatch, useSelector } from "react-redux";
import { clearMessages, getMessages, getNextMessages, handleWebSocket, newMessage } from "../../store/actions/whatsappActions";

const FromThemText = ({text, timestamp}) => {   //component untuk text dari WA
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginTop: "10px",
        justifyContent: "flex-start",
      }}
    >
      <div
        style={{
          padding: "10px",
          borderRadius: "10px",
          backgroundColor: "rgba(245, 245, 245)",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          whiteSpace: "pre-line"
        }}
      >
        <span className="message-content" style={{marginRight: "10px", flex: "1 1 auto"}}>{text}</span>
        <small style={{textAlign: "right", color: "gray", flexShrink: 0, marginLeft: "auto", marginTop: "auto"}}>{timestamp}</small>
      </div>
    </div>
  )
}

const FromMeText = ({text, timestamp}) => { //component untuk text dari kita
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginTop: "10px",
        justifyContent: "flex-end",
      }}
    >
      <div
        style={{
          padding: "10px",
          borderRadius: "10px",
          backgroundColor: "rgba(220, 248, 198)",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          whiteSpace: "pre-line"
        }}
      >
        <span className="message-content" style={{marginRight: "10px", flex: "1 1 auto"}}>{text}</span>
        <small style={{textAlign: "right", color: "gray", flexShrink: 0, marginLeft: "auto", marginTop: "auto"}}>{timestamp}</small>
      </div>
    </div>
  );
}

const DocumentMessage = ({text, timestamp}) => { //component untuk text dari WA yang berformat document
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginTop: "10px",
        width: "100%",
      }}
    >
        <div style={{
          height: "130px", 
          display: "flex", 
          alignItems: "end", 
          borderRadius: "10px", 
          backgroundImage: "url(https://pnghq.com/wp-content/uploads/pdf-logo-png-png-no-watermark-41801-300x296.png)",
          backgroundSize: "auto 80px",
          backgroundRepeat: "no-repeat",
          backgroundPosition: 'center',
          backgroundColor: "rgba(245, 245, 245)",
          width: "100%",
          }}>
          <div
            style={{
              backgroundColor: "rgba(235, 235, 235)",
              padding: "10px",
              borderRadius: "10px",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              width: "100%",
            }}
          >
            <a href="#" className="message-content" style={{marginRight: "10px", flex: "1 1 auto"}}>{text} <i className="fa fa-download" aria-hidden="true"></i></a>
            <small style={{textAlign: "right", color: "gray", flexShrink: 0, marginLeft: "auto"}}>{timestamp}</small>
          </div>
        </div>
    </div>
  )
}

const ImageMessage = ({text, timestamp}) => { //component untuk text dari WA yang berformat Image
  return (
    <div
      style={{
        display: "flex",
        maxWidth: "100%",
        alignItems: "center",
        gap: "10px",
        marginTop: "10px",
        width: "50%",
      }}
    >
        <div style={{
          height: "130px", 
          display: "flex", 
          maxWidth: "100%",
          flexDirection: "column",
          justifyContent: "end", 
          borderRadius: "10px", 
          backgroundImage: "url(https://cdn3.iconfinder.com/data/icons/it-and-ui-mixed-filled-outlines/48/default_image-1024.png)",
          backgroundSize: "auto 80px",
          backgroundRepeat: "no-repeat",
          backgroundPosition: 'center',
          backgroundColor: "rgba(245, 245, 245)",
          width: "100%",
          position: "relative",
          }}
        >
          <div
            style={{
              backgroundColor: text ? "rgba(235, 235, 235)" : "rgba(0,0,0,0)",
              padding: "10px",
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div className="d-flex" style={{whiteSpace: "pre-line", flexWrap: "wrap"}}>
              <div className="message-content" style={{marginRight: "10px", flex: "1 1 auto"}}>{text}</div>
              <small style={{textAlign: "right", color: "gray", flexShrink: 0, marginLeft: "auto", fontSize: "10px", justifyContent: "end"}}>{timestamp}</small>
            </div>  
          </div>
        </div>
    </div>
  )
}

const WhatsappDrawer = ({whatsAppDrawer, setWhatsappDrawer, phoneNumber, chatName}) => {
  const dispatch = useDispatch()
  const dataWA = useSelector(state => state.whatsapp)
  const {messages, loading, next} = dataWA
  const loadingRef = useRef(false);
  const nextRef = useRef();
  const isOpened = useRef(false);
  const phoneNumRef = useRef("");
  const chatRef = useRef(null);
  const scrollPosition = useRef(null);
  const skipAutoScroll = useRef(false);
  const [newMessageState, setNewMessageState] = useState("");

  useEffect(() => {nextRef.current = next}, [next])
  useEffect(() => {phoneNumRef.current = phoneNumber}, [phoneNumber])
  useEffect(() => {loadingRef.current = loading}, [loading])

  const [customerLastMessage, setCustomerLastMessage] = useState();

  useEffect(() => {
    let lastDiff = null;

    for (let i = messages.length - 1; i >= 0; i--) {
      const element = messages[i];
      const type = element?.data?.[0]?.changes?.[0]?.value?.messages?.[0]?.type;

      if (type !== undefined) {
        const date = new Date(element?.created_at);
        const currentDate = new Date();

        const diffMs = Math.abs(date - currentDate);
        const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));

        lastDiff = diffDays;
        break; // ✅ stop at the *last* one from the end
      }
    }

    if (lastDiff !== null) {
      setCustomerLastMessage(lastDiff);
    }else{
      setCustomerLastMessage(2)
    }
  }, [messages]);

    const handleSendTemplate = async (template_id) => {      
      dispatch(newMessage(template_id, phoneNumber));
    }

  const handleNewMessage = async (e) => {  //api request untuk messsage baru
    e.preventDefault();

    const x = newMessageState
    skipAutoScroll.current = false;
    setNewMessageState("")
    dispatch(newMessage(x, phoneNumber));
  }

  useEffect(() => {     //web socket connection
    const channel = echo.channel("Whatsapp")
    .listen('WhatsappMessage', (x) => {
      const phoneNum = x.data.data[0].changes?.[0]?.value.contacts[0].wa_id;
      skipAutoScroll.current = true;
      dispatch(handleWebSocket(x.data, phoneNum, phoneNumRef.current , isOpened.current));
    })

    return () => {
      channel.stopListening('WhatsappMessage');
      echo.leaveChannel('Whatsapp');
    };
  }, []);

  useEffect(() => {       
    if(whatsAppDrawer){
      skipAutoScroll.current = false;
      dispatch(getMessages(phoneNumber)) //saat whatsapp drawer terbuka laksanakan api request

      const chatElement = chatRef.current;
      if (chatElement) {
        chatElement.addEventListener("scroll", handleScroll); //saat whatsapp drawer terbuka add event listener buat scroll
      }

      isOpened.current = true;
    }else {
      chatRef?.current?.removeEventListener("scroll", handleScroll);
      dispatch(clearMessages());
      isOpened.current = false;
    }
  }, [whatsAppDrawer]);

  useEffect(() => {
    if(!chatRef) return;
    if (chatRef.current && !skipAutoScroll.current) {    //auto scroll kebawah saat messages berubah
      chatRef.current.scrollTop = chatRef.current?.scrollHeight;
    }else if(skipAutoScroll.current){
      chatRef.current.scrollTop = chatRef.current?.scrollHeight - scrollPosition.current;
    }

    const hasScrollbar = chatRef.current?.scrollHeight > chatRef.current?.clientHeight;

    if(!hasScrollbar && nextRef.current !== null && !loadingRef.current) {
      dispatch(getNextMessages(nextRef.current, phoneNumRef.current));
    }
  }, [messages]);

  const handleScroll = useCallback(() => {
    //function untuk handle scroll
    if (!chatRef.current) return;
    if (chatRef.current.scrollTop === 0 && !loadingRef.current && nextRef.current !== null) {
      scrollPosition.current = chatRef.current.scrollHeight - chatRef.current.scrollTop;
      skipAutoScroll.current = true;
      dispatch(getNextMessages(nextRef.current, phoneNumRef.current));
    }
  }, [])

  const closeWhatsappDrawer = () => {   //bersihin state saat drawer ditutup
    phoneNumber = 0;
    setWhatsappDrawer(false);
  };

  return (
    <Drawer
      title="Whatsapp"
      onClose={closeWhatsappDrawer}
      open={whatsAppDrawer}
      style={{
        padding: "0px"
      }}
    >
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "10px",
          padding: "0px"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            backgroundColor: "#25d366",
            padding: "10px",
            borderRadius: "10px",
            width: "100%",
          }}
        >
          <i
            className="fa fa-whatsapp text-white"
            style={{ fontSize: "45px" }}
          ></i>
          <span
            style={{ fontSize: "20px", fontWeight: "bold", color: "white" }}
          >
            {chatName}
          </span>
        </div>

        <div style={{ height: "100%", width: "100%", overflowY: "scroll", overflowX: "hidden"}} ref={chatRef}>
          <div style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
          }}>{loading ? <Spin size="large" style={{position: "fixed"}} /> : ""}</div>
        
          {
              messages.map((element, key) => {
                  Date.prototype.toString = function () {
                      return this.toLocaleString(); // Automatically uses local format
                  };

                  const date = new Date(element?.created_at)
                  const currentDate = new Date()

                  const x = date.toString().split(" ");
                  const y = x[1].split(":");
                  const hour = y[0]+":"+y[1]+" "+x[2]

                  const diffMs = Math.abs(date - currentDate);
                  const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));
                  const diffWeeks = Math.round(diffMs / (1000 * 60 * 60 * 24 * 7));

                  const isDiffrentDay = messages?.[key]?.created_at?.split(" ")[0].split("-")[2] !== messages?.[key - 1]?.created_at.split(" ")[0].split("-")[2] && messages?.[key - 1] !== undefined;

                  let timestamp;

                  if(diffDays === 0){
                    timestamp = `Today`;
                  }else if(diffDays === 1){
                    timestamp = "Yesterday"
                  }else if(diffDays > 1 && diffDays < 7){
                    timestamp = `${diffDays} days ago`
                  }else if(diffDays >= 7 && diffDays < 14){
                    timestamp = "1 week ago"
                  }else if(diffDays >= 14 && diffDays < 70){
                    timestamp = `${diffWeeks} weeks ${diffDays % 7} days ago`
                  }else{
                    const day = date.getDate().toString().padStart(2, "0"); // Ensures 2-digit format
                    const month = (date.getMonth() + 1).toString().padStart(2, "0");
                    const year = date.getFullYear()
                    timestamp = `${day}/${month}/${year}`;
                  }

                  switch(element.data?.[0]?.changes?.[0]?.value?.messages?.[0].type){
                    case "document": {
                        let reply = element.data?.[0]?.changes?.[0]?.value?.messages?.[0]?.context?.id;

                        if(isDiffrentDay){
                            return [
                            <div style={{width: "90%", border: "solid lightgray 1px", marginTop: "10px", marginRight: "25px", marginLeft: "25px"}} key={`serperator-${key}`}></div>,
                            <p style={{width: "100%", textAlign: "center", color: "gray", marginBottom: "10px"}} key={`date-${key}`}>{timestamp}</p>,

                            <DocumentMessage key={key} text={element.data?.[0]?.changes?.[0]?.value?.messages?.[0].document.filename} timestamp={hour} messageId={element.data?.[0]?.changes?.[0]?.value?.messages?.[0].id} replyId={reply}/>
                          ]
                        }
                        
                        return <DocumentMessage key={key} text={element.data?.[0]?.changes?.[0]?.value?.messages?.[0].document.filename} timestamp={hour}  messageId={element.data?.[0]?.changes?.[0]?.value?.messages?.[0].id} replyId={reply}/>
                    }
                    case "text": {
                        let reply = element.data?.[0]?.changes?.[0]?.value?.messages?.[0]?.context?.id;
                        if(isDiffrentDay){
                            return [
                            <div style={{width: "90%", border: "solid lightgray 1px", marginTop: "10px", marginRight: "25px", marginLeft: "25px"}} key={`serperator-${key}`}></div>,
                            <p style={{width: "100%", textAlign: "center", color: "gray", marginBottom: "10px"}} key={`date-${key}`}>{timestamp}</p>,

                            <FromThemText key={key} text={element.data?.[0]?.changes?.[0]?.value?.messages?.[0].text.body} timestamp={hour}  messageId={element.data?.[0]?.changes?.[0]?.value?.messages?.[0].id} replyId={reply}/>
                          ]
                        }
      
                        return <FromThemText key={key} text={element.data?.[0]?.changes?.[0]?.value?.messages?.[0].text.body} timestamp={hour}  messageId={element.data?.[0]?.changes?.[0]?.value?.messages?.[0].id} replyId={reply}/>
                    }
                    case "image": {
                      if(isDiffrentDay){
                          return [
                          <div style={{width: "90%", border: "solid lightgray 1px", marginTop: "10px", marginRight: "25px", marginLeft: "25px"}} key={`serperator-${key}`}></div>,
                          <p style={{width: "100%", textAlign: "center", color: "gray", marginBottom: "10px"}} key={`date-${key}`}>{timestamp}</p>,

                          <ImageMessage key={key} text={element.data?.[0]?.changes?.[0]?.value?.messages?.[0]?.image?.caption} timestamp={hour}/>
                        ]
                      }
    
                      return <ImageMessage key={key} text={element.data?.[0]?.changes?.[0]?.value?.messages?.[0]?.image?.caption} timestamp={hour}/>
                  }
                    default: {
                        try {
                        let reply = element.data?.context?.message_id;
                        
                        if(element.data.type == "text"){
                          if(isDiffrentDay){
                            return [
                              <div style={{width: "90%", border: "solid lightgray 1px", marginTop: "10px", marginRight: "25px", marginLeft: "25px"}} key={`serperator-${key}`}></div>,
                              <p style={{width: "100%", textAlign: "center", color: "gray", marginBottom: "10px"}} key={`date-${key}`}>{timestamp}</p>,
                              <FromMeText 
                                key={key} 
                                text={element.data.text.body} 
                                timestamp={hour} 
                                messageId={element.id} 
                                replyId={reply}
                               />
                            ]
                          }else{
                            return <FromMeText key={key} text={element.data.text.body} timestamp={hour} messageId={element.id} replyId={reply}/>
                          }
                        }else if(element.data.type == "template"){
                          let template_message;
                          switch(element.data.template.name){
                            case "utility_id_3": {
                              template_message = "Balas dengan Ya, jika Anda ingin tetap melanjutkan percakapan"
                              break
                            }
                          }
                          if(isDiffrentDay){
                            return [
                              <div style={{width: "90%", border: "solid lightgray 1px", marginTop: "10px", marginRight: "25px", marginLeft: "25px"}} key={`serperator-${key}`}></div>,
                              <p style={{width: "100%", textAlign: "center", color: "gray", marginBottom: "10px"}} key={`date-${key}`}>{timestamp}</p>,
                              <FromMeText 
                                key={key}
                                text={template_message}
                                timestamp={hour}
                                messageId={element.id} 
                                replyId={reply}
                               />
                            ]
                          }else{
                            return <FromMeText key={key} text={template_message} timestamp={hour} messageId={element.id} replyId={reply}/>
                          }
                        }
                      }catch(e){
                      }
                    }
                  }
              })
          }

          {
            messages.length === 0 && !loading ? <h2 style={{width: "100%", textAlign: "center"}}>No Messages Yet!</h2> : ""
          }

        </div>

        <div style={{ width: "100%" }}>
            <form onSubmit={handleNewMessage} style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", padding: "1px" }}>
              <div style={{ width: "90%", padding: "1px" }}>                
                <div style={{width: "100%", display: "flex"}}>
                  <textarea
                      style={{ width: "100%", borderRadius: "10px", border: "none", backgroundColor: customerLastMessage > 1 ? "lightgray" : "rgba(235, 235, 235)", resize: "none"}}
                      placeholder="Type a message"
                      onChange={(e) => setNewMessageState(e.target.value)} 
                      value={newMessageState}
                      rows={1}
                      disabled={customerLastMessage > 1}
                    />
                  <Dropdown menu={{ items: [
                                    { key: "utility_id_3", label: "Balas dengan Ya, jika Anda ingin tetap melanjutkan percakapan" },
                                  ], 
                                  onClick: ({key}) => {
                                    handleSendTemplate(key)
                                  } }}  trigger={["click"]}
                            placement="top"
                  >
                    <button style={{border: "none", outline: "none", backgroundColor: "transparent"}}><i className="fa fa-angle-down text-secondary" style={{fontSize: "20px"}}></i></button>
                  </Dropdown>
                </div>
              </div>
              <div
                className="d-flex flex-column"
                style={{
                  width: "10%",
                  justifyContent: "flex",
                  height: "100%"
                }}
              >
                <button
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "10px",
                    backgroundColor: "#25d366",
                    color: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "none",
                    height: "40px",
                    marginTop: "auto"
                  }}
                >
                  <i className="fa fa-paper-plane" aria-hidden="true"></i>
                </button>
              </div>
            </form>
        </div>
      </div>
    </Drawer>
  );
};




export default WhatsappDrawer;
